import { map } from 'rxjs/operators';

import AlertDialog from '../components/common/AlertDialog';
import ChangeIntroductionDialog from '../components/editWorkspace/ChangeIntroductionDialog';
import ValidationException from '../exceptions/ValidationException';

export default class EditWorkspaceBloc {
  constructor({ workspaceRepository, authRepository, dialogRepository }) {
    this.workspaceRepository = workspaceRepository;
    this.authRepository = authRepository;
    this.dialogRepository = dialogRepository;
  }

  async updateWorkspace(data) {
    const image = data.logoUrl;
    if (image?.size / 1024 / 1024 > 3) {
      throw new ValidationException([
        {
          constraints: {
            logoUrl: 'Logo image can not be larger than 3MB',
          },
          property: 'logoUrl',
        },
      ]);
    }
    await this.workspaceRepository.updateWorkspace(data, this.authRepository.auth$.getValue().workspaceId);
    this.dialogRepository.loadDialog(AlertDialog, {
      btnAction: () => this.dialogRepository.toggleDialog(false),
      btnText: 'Dismiss',
      message: 'You have changed the visual appearance of your workspace. The changes will reflect on your next login',
      title: 'Successfully Updated',
    });
  }

  async updateGlobalVideoDescription(globalVideoIntroduction) {
    const payload = {
      globalVideoIntroduction,
      primaryColor: this.workspace$.getValue().primaryColor,
    };
    await this.workspaceRepository.updateWorkspace(payload, this.authRepository.auth$.getValue().workspaceId);
    this.workspace$.next({
      ...this.workspace$.getValue(),
      globalVideoIntroduction,
    });
    this.dialogRepository.loadDialog(AlertDialog, {
      btnAction: () => this.dialogRepository.toggleDialog(false),
      btnText: 'Dismiss',
      message: 'You have changed the Global video Introduction',
      title: 'Successfully Updated',
    });
  }

  get workspace$() {
    return this.authRepository.userWorkspace$;
  }

  get userRole$() {
    return this.authRepository.auth$.pipe(map((auth) => auth?.role));
  }

  get currentUser$() {
    return this.authRepository.auth$;
  }

  openChangeIntroduction() {
    this.dialogRepository.loadDialog(ChangeIntroductionDialog, {
      onApplyChange: (value) => this.updateGlobalVideoDescription(value),
      text: this.workspace$.getValue().globalVideoIntroduction,
    });
  }
}
